import { render, staticRenderFns } from "./alterationdept.vue?vue&type=template&id=f437522a&scoped=true"
import script from "./alterationdept.vue?vue&type=script&lang=js"
export * from "./alterationdept.vue?vue&type=script&lang=js"
import style0 from "./alterationdept.vue?vue&type=style&index=0&id=f437522a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f437522a",
  null
  
)

export default component.exports